var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80C29.3156 80 19.2706 75.8394 11.7156 68.2844C4.16063 60.7294 0 50.6844 0 40C0 29.3156 4.16078 19.2708 11.7156 11.7156C19.2705 4.16047 29.3156 0 40 0C50.6844 0 60.7294 4.16063 68.2844 11.7156C75.8394 19.2706 80 29.3156 80 40C80 50.6844 75.8392 60.7292 68.2844 68.2844C60.7295 75.8395 50.6844 80 40 80ZM40 5C20.7009 5 5 20.7009 5 40C5 59.2991 20.7009 75 40 75C59.2991 75 75 59.2991 75 40C75 20.7009 59.2991 5 40 5Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37.5C36.5538 37.5 33.75 34.6963 33.75 31.25C33.75 27.8038 36.5538 25 40 25C43.4462 25 46.25 27.8038 46.25 31.25C46.25 32.6306 47.3692 33.75 48.75 33.75C50.1308 33.75 51.25 32.6306 51.25 31.25C51.25 25.9061 47.5034 21.4237 42.5 20.2834V17.5C42.5 16.1194 41.3808 15 40 15C38.6192 15 37.5 16.1194 37.5 17.5V20.2834C32.4966 21.4237 28.75 25.9061 28.75 31.25C28.75 37.4533 33.7967 42.5 40 42.5C43.4462 42.5 46.25 45.3037 46.25 48.75C46.25 52.1963 43.4462 55 40 55C36.5538 55 33.75 52.1963 33.75 48.75C33.75 47.3694 32.6308 46.25 31.25 46.25C29.8692 46.25 28.75 47.3694 28.75 48.75C28.75 54.0939 32.4966 58.5763 37.5 59.7166V62.5C37.5 63.8806 38.6192 65 40 65C41.3808 65 42.5 63.8806 42.5 62.5V59.7166C47.5034 58.5763 51.25 54.0939 51.25 48.75C51.25 42.5467 46.2033 37.5 40 37.5Z",
    fill: "#7C7C7C"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.878208106ca53d6a26c2bcbe9f0f1b58.svg";
export { ForwardRef as ReactComponent };